import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class SmallFractionDisplay extends Phaser.GameObjects.Container {
  constructor(scene, cont) {
    super(scene);
    cont ? cont.add(this) : scene.add.existing(this);

    this.scene = scene;

    this.lineWidth = 0;

    this.numeratorDisplay = this.scene.add.bitmapText(5, -8, 'asapBold', '1', 16);
    this.add(this.numeratorDisplay);
    this.denominatorDisplay = this.scene.add.bitmapText(5, 12, 'asapBold', '12', 16);
    this.add(this.denominatorDisplay);

    this.line = ABCyaPhaser.Images.addImage(0, 1, 'FractionLine', this).setOrigin(0, 0);

    this.lineWidth = this.line.getBounds().width;
  }

  updateDisplay(fraction) {
    this.fraction = fraction;
    this.numeratorDisplay.text = this.fraction.numerator.toString();
    this.denominatorDisplay.text = this.fraction.denominator.toString();
    this.numeratorDisplay.x = this.lineWidth / 2 - this.numeratorDisplay.width / 2;
    this.denominatorDisplay.x = this.lineWidth / 2 - this.denominatorDisplay.width / 2;
  };
}